module.exports = __webpack_public_path__ + "static/media/christmas_background.461877f3.svg";